import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Table,
  InputGroup,
  Tab,
  Offcanvas,
} from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../config/Config";
import { useSelector, useDispatch } from "react-redux";
import { fetchProjectList } from "../redux/projectReducer";
import { fetchAssignList } from "../redux/AssignReducer";
import { fetchAllAssignedProjects, fetchReceiveAssignedProjects, fetchSentAssignedProjects } from '../redux/AssigneProject-redux/AssigneProjectsReducer'
import './Assigned.css'
import axios from "axios";

function formatDisplayDate(dateVal) {
  if (!dateVal) return '-';
  if (typeof dateVal === 'string') {
    const trimmed = dateVal.trim();
    const ddmmyyyyMatch = trimmed.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (ddmmyyyyMatch) {
      const day = ddmmyyyyMatch[1].padStart(2, '0');
      const month = ddmmyyyyMatch[2].padStart(2, '0');
      const year = ddmmyyyyMatch[3];
      return `${day}/${month}/${year}`;
    }
    const d = new Date(trimmed);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('en-GB');
    }
    return trimmed;
  }
  if (dateVal instanceof Date && !isNaN(dateVal.getTime())) {
    return dateVal.toLocaleDateString('en-GB');
  }
  const d = new Date(dateVal);
  return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('en-GB');
}

export default function Assigned() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [stateOfData, SetstateOfData] = useState('sent')
  const [assigndata, SetAssigndata] = useState([])
  const [page, SetPage] = useState([])
  console.log("page", page);
  const [lim] = useState(10);
  const location = useLocation();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.assignedProjects);
  // const {allAssigneData}= useSelector((state)=>state.assigneProjects)
  const { sentAssignedData, receiveAssignedData, status, error } = useSelector((state) => state.assigneProjects)
  console.log("rock sentAssignedData", sentAssignedData);
  console.log("rock receiveAssignedData", receiveAssignedData);



  const userUID = localStorage.getItem("userUID");

  console.log("userUID", userUID);
  // Fetch Assigne Project 

  // Fetch project list
  // useEffect(() => {
  //   dispatch(fetchProjectList({ userUID, page: currentPage, lim }));
  // }, [currentPage, lim, dispatch]);

  // Fetch fetch All Assigned Projects list
  // useEffect(() => {
  //   dispatch(fetchAllAssignedProjects({userUID}));
  // }, [dispatch,stateOfData]);

  // Fetch  Sent All Assigned Projects list
  useEffect(() => {
    dispatch(fetchSentAssignedProjects(userUID));
  }, [currentPage, lim, dispatch]);

  // Fetch  Received All Assigned Projects list
  useEffect(() => {
    dispatch(fetchReceiveAssignedProjects(userUID));
  }, [currentPage, lim, dispatch]);

  // Fetch assigned list
  // useEffect(() => {
  //   dispatch(fetchAssignList({ userUID}));
  // }, [dispatch, userUID]);

  // Handle authentication
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      navigation(user ? "/assigned" : "/login");
    });

    return () => unsubscribe();
  }, [navigation]);



  useEffect(() => {
    if (stateOfData === "inBox") {
      SetAssigndata(receiveAssignedData.clients);
      SetPage(receiveAssignedData)
    } else if (stateOfData === "sent") {
      SetAssigndata(sentAssignedData.clients);
      SetPage(sentAssignedData)
    }
  }, [stateOfData, receiveAssignedData, sentAssignedData]);
  console.log("stateOfData", stateOfData);


  //////////////////////////////////////////////////////////////////

  const [show, setShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [userList, setUserList] = useState({});
  console.log("userList", userList);
  console.log("selectedProject", selectedProject);

  const handleClose = () => setShow(false);

  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);
  console.log('userData', userData);

  const handleShow = async (project) => {
    const filteredUserID = stateOfData === 'sent' ? project.assigneeToId : project.ID;

    console.log("filteredUserID", filteredUserID);
    console.log("project", project);
    try {
      const response = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/users/${filteredUserID}`);
      const data = await response.json();
      console.log("Fetched data:", data); // Log the full response to check its structure

      // Add this check to see if users are directly in data or under a different key
      // if (!data || !Array.isArray(data)) {
      //   console.error("Data is not in the expected format:", data);
      //   return;
      // }
      console.log("Data is not in the expected format:", data);
      setUserList(data); // Set the formatted data as options for Autocomplete
      setShow(true);
      setSelectedProject({ ...data, ...project });
    } catch (error) {
      console.error('Error fetching user list:', error);
    }

  };


  return (
    <Container fluid>
      <Row className="m-0">
        <Col sm={1}></Col>
        <Col sm={11}>
          <Row className="mt-5">
            <Col>
              <Row className="headingPart">
                <Col sm={11} >
                  <div className="AssignedProjectsBox">
                    <div >
                      <h4>Assigned Projects</h4>
                    </div>
                    <Form>
                      <InputGroup>
                        <Form.Control
                          style={{
                            borderRadius: "15px",
                            padding: "12px 15px",
                            border: "1px solid #d1d5db",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                            transition: "all 0.3s ease",
                            width: "20vw",
                          }}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search Projects"
                        />
                      </InputGroup>
                    </Form>
                    <div className="AssignedProjectsButton">
                      <span>
                        <button onClick={() => SetstateOfData('sent')} className={` ${stateOfData === 'sent' ? 'activeButton' : 'buttonDesign'}`}>SENT </button>
                      </span>
                      <span>
                        <button onClick={() => SetstateOfData('inBox')} className={` ${stateOfData === 'inBox' ? 'activeButton' : 'buttonDesign'}`}>INBOX</button>
                      </span>
                    </div>


                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col sm={12} >
                  <div className="table-container">
                    <div className="tableScroll">
                      <table>
                        <thead>
                          <tr>
                            <th>Project</th>
                            <th>Name</th>
                            <th>Number</th>
                            <th>Create</th>
                            <th>Status</th>
                            <th>Created By</th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {(search.toLowerCase() === ''
                            ? assigndata
                            : assigndata?.filter((project) => {
                              const searchQuery = search.toLowerCase();
                              return (
                                (project.pname?.toLowerCase().includes(searchQuery) || '') ||
                                (project.cname?.toLowerCase().includes(searchQuery) || '') ||
                                (project.cphone ? String(project.cphone).toLowerCase().includes(searchQuery) : false)
                              );
                            })
                          )?.map((project) => (
                            <tr key={project.id}>
                              <td>{project.pname}</td>
                              <td>{project.cname}</td>
                              <td>{project.cphone}</td>
                              <td>{formatDisplayDate(project.date || project.dateTimec || project.timestamp)}</td>
                              <td>{project.status}</td>
                              <td>
                                <button
                                  className="buttonDesign"
                                  onClick={() => handleShow(project)}
                                >
                                  Info
                                </button>
                              </td>
                              <td>
                                {/* <button
                                  className="buttonDesign"
                                // TODO: Add delete functionality if needed
                                >
                                  DELETE
                                </button> */}
                              </td>
                              <td>
                                <button
                                  className="buttonDesign"
                                  onClick={() => {
                                    navigation('/assigned/view-rooms', { state: { ...project, from: stateOfData } });
                                  }}
                                >
                                  {stateOfData === 'sent' ? 'View Rooms' : 'Edit Rooms'}
                                </button>
                              </td>
                            </tr>
                          ))}

                          {/* If no projects found after filtering */}
                          {/* {assigndata?.length === 0 && (
                            <tr>
                              <td colSpan="9" className="noDataFound">No lost projects found.</td>
                            </tr>
                          )} */}
                        </tbody>
                      </table>
                      {assigndata?.length === 0 && (
                        <div>
                          <p colSpan="9" className="noDataFound">No Assigned  projects found.</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <Offcanvas show={show} onHide={handleClose} placement="end" >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Project Details</Offcanvas.Title>
                    </Offcanvas.Header>
                    <hr />
                    <Offcanvas.Body>
                      <div className="detailscontainer">
                        <div className="detail-item">
                          <h5 className="detail-label">{stateOfData === "sent" ? 'Send to:' : 'Assignor Name:'}</h5>
                          <h6 className="detailvalue">{stateOfData === "sent" ? selectedProject?.name : selectedProject?.name}</h6>
                        </div>
                        <div className="dotted-separator"></div> {/* Dotted Line */}
                        <div className="detail-item">
                          <h5 className="detail-label">{stateOfData === "sent" ? 'Assignee Designation:' : 'Assignor Designation:'}</h5>
                          <h6 className="detailvalue">{selectedProject?.designation || "N/A"}</h6>
                        </div>
                        <div className="dotted-separator"></div> {/* Dotted Line */}
                        <div className="detail-item">
                          <h5 className="detail-label">{stateOfData === "sent" ? 'Assignee Email:' : 'Assignor Email:'}</h5>
                          <h6 className="detailvalue">{selectedProject?.email || "N/A"}</h6>
                        </div>
                        <div className="dotted-separator"></div> {/* Dotted Line */}
                        <div className="detail-item">
                          <h5 className="detail-label">{stateOfData === "sent" ? 'Assignee Time:' : 'Assignor Time:'}</h5>
                          <h6 className="detailvalue">{selectedProject?.assignedAt
                            ? new Date(selectedProject.assignedAt.seconds * 1000).toLocaleString()
                            : 'N/A'}</h6>
                        </div>
                        <div className="dotted-separator"></div> {/* Dotted Line */}
                      </div>
                    </Offcanvas.Body>
                  </Offcanvas>
                </Col>
              </Row>
              <Row style={{
                marginTop: '1vh',
              }} >
                <Col sm={1}>
                </Col>
                <Col sm={11}>
                  <hr />
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1rem'
                  }} >
                    <button className="buttonDesign" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                      Previous
                    </button>
                    <span >Page {currentPage}</span>
                    {page.hasNextPage && (
                      <button
                        className="buttonDesign"
                        onClick={() => setCurrentPage(prev => prev + 1)}
                      >
                        Next
                      </button>
                    )}

                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>

  );
}
